export interface MenuFooterInfo {
  helpCenterUrl?: string;
  importExportUrl?: string;
  bugReportUrl?: string;
  messagesUrl?: string;
}
